import { DropTarget } from 'assets/js/pages/campaign-settings/campaign-event/table-seating/constants';
import { containerDropReducer } from 'assets/js/pages/campaign-settings/campaign-event/table-seating/reducers/containerDrop';
import { DropType } from 'assets/js/pages/campaign-settings/campaign-event/table-seating/reducers/dropTypes';
import { emptySeatReducer } from 'assets/js/pages/campaign-settings/campaign-event/table-seating/reducers/emptySeat';
import { ticketDropReducer } from 'assets/js/pages/campaign-settings/campaign-event/table-seating/reducers/ticketDrop';
import {
    ActionInstruction,
    DropAction,
    ReducerState,
    StoreAction,
} from 'assets/js/pages/campaign-settings/campaign-event/table-seating/reducers/types';
import { DropTargetPayload } from 'assets/js/pages/campaign-settings/campaign-event/table-seating/types';

const tableSeatingReducer = (state: ReducerState, action: DropAction): ActionInstruction => {
    const dropActionType = determineDropActionType(action.payload.overData);

    switch (dropActionType) {
        case DropType.DROP_ON_EMPTY_SEAT:
            return emptySeatReducer(state, action);

        case DropType.DROP_TICKET:
            return ticketDropReducer(state, action);

        case DropType.DROP_ON_CONTAINER:
            return containerDropReducer(state, action);

        default:
            return {
                action: StoreAction.SHOW_ERROR,
                payload: { message: 'Invalid drop action' },
            };
    }
};

const determineDropActionType = (overData: DropTargetPayload): DropType => {
    switch (overData.type) {
        case DropTarget.EMPTY_SEAT:
            return DropType.DROP_ON_EMPTY_SEAT;

        case DropTarget.TICKET:
        case DropTarget.OCCUPIED_SEAT:
            return DropType.DROP_TICKET;

        case DropTarget.UNSEATED_CONTAINER:
        case DropTarget.SEATING_CONTAINER:
            return DropType.DROP_ON_CONTAINER;

        default:
            return DropType.NO_OP;
    }
};

export { tableSeatingReducer, determineDropActionType };
